var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4663 48.3814L23.1101 36.6873L27.5214 42.314L19.0188 53.1267C15.7624 57.2644 9.73678 52.9041 13.4663 48.3814ZM24.729 21.7507C25.6474 18.7542 25.2253 16.1936 21.7741 12.3899L13.341 2.24512C12.1442 0.839602 9.32394 2.90381 10.5022 4.6062L17.2468 12.9141C18.5224 14.4634 16.1521 16.5137 14.8347 14.918L7.85812 6.32715C6.55929 4.83814 3.8735 6.80493 5.23263 8.50733C7.19942 10.873 10.2424 14.7371 12.2092 17.1028C13.573 18.4897 11.4995 20.5447 10.1543 18.8145L3.22872 10.2793C2.21285 9.17529 0.552207 9.86182 0.111533 11.1514C-0.361611 12.5291 0.802696 13.5356 1.59591 14.5562L9.32394 24.5386C11.7221 27.3171 14.4033 28.9639 17.5205 28.0315C17.9983 27.8877 18.5827 27.5955 19.2089 27.2105L39.9716 54.0127C41.0896 55.4553 43.2465 55.6084 44.6474 54.4441L44.9675 54.1797C46.5446 52.8669 46.7998 50.4688 45.4499 48.9194L23.4626 23.6572C24.1027 22.9429 24.5713 22.2656 24.729 21.7507ZM30.6062 27.5955L34.0249 23.4485C29.6274 12.5476 45.9231 -1.98071 53.8227 4.69898C63.4201 12.8213 49.1562 32.3965 39.132 27.5584L35.0825 32.7026L30.6062 27.5955Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.9b2d6edf43c78d4e62b1d5372a4026b6.svg";
export { ForwardRef as ReactComponent };